var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c(
        "el-dialog",
        {
          staticClass: "mldialog",
          class: { "not-header": _vm.notHeader, isFullSceen: _vm.isFullSceen },
          attrs: {
            "append-to-body": _vm.appendToBody,
            width: _vm.isFullSceen ? "100%" : _vm.width,
            "show-close": false,
            "close-on-click-modal": _vm.closeOnClickModal,
            top: _vm.isFullSceen ? "0" : _vm.top,
            draggable: _vm.draggable,
          },
          on: { close: _vm.close },
          scopedSlots: _vm._u(
            [
              {
                key: "header",
                fn: function () {
                  return [
                    _c("span", { staticClass: "my-title" }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _vm._v(" "),
                    _vm.showClose
                      ? _c(
                          "span",
                          {
                            staticClass: "fr close-icon",
                            on: { click: _vm.close },
                          },
                          [
                            _c(
                              "el-icon",
                              { attrs: { size: "20" } },
                              [_c("ElIconClose")],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showFullSceen
                      ? _c(
                          "span",
                          {
                            staticClass: "fr full-screen-icon",
                            on: { click: _vm.onFullSceen },
                          },
                          [
                            _c(
                              "el-icon",
                              { attrs: { size: "20" } },
                              [_c("ElIconFullScreen")],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              _vm.isShowFooter
                ? {
                    key: "footer",
                    fn: function () {
                      return [_vm._t("footer")]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [_vm._v(" "), _vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }